// extracted by mini-css-extract-plugin
export default {"SearchPanel":"SearchPanel_SearchPanel__SHR9I","SearchBar":"SearchPanel_SearchBar__6zy3P","Input":"SearchPanel_Input__ywsF4"};